import type { ParseResult } from './types';

type ParseWorkerResponse = {
  ok: true;
  result: ParseResult;
} | {
  ok: false;
  error: {
    message: string;
    name: string;
  };
};

export async function parseCanLogFileInWorker(file: File): Promise<ParseResult> {
  const buffer = await file.arrayBuffer();
  const worker = new Worker(new URL('./parser.worker.ts', import.meta.url), { type: 'module' });

  return new Promise((resolve, reject) => {
    worker.onmessage = (event: MessageEvent<ParseWorkerResponse>) => {
      worker.terminate();
      const message = event.data;
      if (message.ok) {
        resolve(message.result);
        return;
      }
      const error = new Error(message.error.message);
      error.name = message.error.name;
      reject(error);
    };

    worker.onerror = (event) => {
      worker.terminate();
      reject(new Error(event.message || 'Unable to parse this capture file.'));
    };

    worker.postMessage({ buffer }, [buffer]);
  });
}
